import styled from "styled-components";

const DropdownItemPadding = styled.div`
    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
`;

export default DropdownItemPadding;